import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";
import {TopButtonPointAction, TopButtonPointEdit, TopButtonPointRemove} from "../../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../../utilities/TabUtilities";
import {Link} from "react-router-dom";

var tinycolor = require("tinycolor2");

export default class EkipyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.formatKierowcy = this.formatKierowcy.bind(this)
        this.formatPojazdy = this.formatPojazdy.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <Link to={'/konfiguracja/zarzadzanie-zasobami/ekipy/' + cell}>
                    <TopButtonPointAction onClick={() => {
                    }}
                                          buttonIcon={'fa fa-bus'}
                                          titleContent={'Zarządzaj zasobami w ekipie'}
                                          className={'btn-zasoby'}/>
                </Link>
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj ekipę'}/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń ekipę'}/>
            </div>
        )
    }

    renderKodEkipy(cell, row) {

        let color = 'grey';

        if ((tinycolor(row.kolor)).isDark()) {
            color = '#ffffff'
        }
        if ((tinycolor(row.kolor)).isLight()) {
            color = '#000000'
        }

        return <span className={'label label-ebus-default'}
                     title={row.kolor}
                     style={(row.kolor.length > 1) ? {background: row.kolor, color: color} : {background: '#f5f5f5', color: '#333333'}}>
            {cell}
            </span>
    }

    formatStatusy(cell, row) {
        if (cell == 1) return (<span><i className={'fa fa-check'} style={{color:'forestgreen'}}></i> dostępny</span>)
        else return (<span><i className={'fa fa-times'} style={{color:'firebrick'}}></i> niedostępny</span>)
    }

    formatKierowcy(cell, row) {

        let polaczenie = this.props.kierowcyWekipach.filter(ki => Boolean(ki) ? ki.idEk === cell : false)

        if (polaczenie.length > 0) {
            return polaczenie.map(item => {
                return (
                    ' ' + item.imie + ' ' + item.nazwisko + (Boolean(item.zmiana) ? '<label style="margin-left:3px">(' + item.zmiana + ')</label>' : '')
                )
            })
        } else return ""
    }

    formatPojazdy(cell, row) {
        let polaczenie = this.props.pojazdyWekipach.filter(p => p.idEk === cell)
        if (polaczenie.length > 0) {
            return(
                <div>
                    <ul style={{margin:0}}>
                        {
                            polaczenie.map(item => {
                              return <li>
                                  {item.marka + ' ' + item.model + ' ' + item.nrRej}
                                  {Boolean(item.zmiana) ? <label style={{marginLeft:'3px'}} title={'numer zmiany'}>({item.zmiana})</label>:''}
                                  {Boolean(item.wifi) ? <span style={{marginLeft:'3px', color:'grey'}} title={'wifi'}><i className={'fa fa-wifi'}></i> {item.wifi}</span>:''}
                              </li>
                            })
                        }
                    </ul>
                </div>
            )
        } else return ""
    }

    render() {

        let statusy = {
            1: 'dostępny',
            0: 'niedostępny'
        }

        const options = {
            sizePerPage: 15,  // Showing 15 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };

        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idEk' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='kodEk'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.renderKodEkipy}
                    >Kod ekipy</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazwaEk'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Nazwa ekipy</TableHeaderColumn>

                    <TableHeaderColumn dataField='idEk'
                                       thStyle={tabgrid.tg6} tdStyle={tabgrid.tg6}
                                       dataFormat={this.formatKierowcy}
                    >Kierowcy</TableHeaderColumn>

                    <TableHeaderColumn dataField='idEk'
                                       thStyle={tabgrid.tg7} tdStyle={tabgrid.tg7}
                                       dataFormat={this.formatPojazdy}
                    >Pojazdy</TableHeaderColumn>
                    <TableHeaderColumn dataField='status'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}} dataFormat={this.formatStatusy}
                                       formatExtraData={statusy}
                    >Status</TableHeaderColumn>
                    <TableHeaderColumn dataField='idEk'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunPlusDodatkowaHtml('Zasoby ekipy', '#264459')}</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/definicjaEkipy/components/EkipyTable.js